import { Component, Input, SimpleChanges } from '@angular/core';
import { NewPageService } from '../../new-page.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  standalone: false,
})
export class DetailsComponent {
  @Input() school: any = {};
  displayedClasses: string = '';
  displayedMedium: string = '';
  area: number = 1000;

  ngOnInit(): void {
    this.setMediumDisplay();
    this.setClassRange();
    this.setArea();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      this.setMediumDisplay();
      this.setClassRange();
      this.setArea();
    }
  }

  setClassRange(): void {
    if (this.school.category?.length) {
      if (this.isCategorySelected('Higher secondary education')) {
        this.displayedClasses = '1st to 12th';
      } else if (this.isCategorySelected('Secondary education')) {
        this.displayedClasses = '1st to 8th';
      } else if (this.isCategorySelected('Primary education')) {
        this.displayedClasses = '1st to 5th';
      } else if (this.isCategorySelected('Pre-primary education')) {
        this.displayedClasses = 'Nursery to 1st';
      }
    }
  }

  setMediumDisplay(): void {
    if (this.school.medium?.length) {
      this.displayedMedium =
        this.school.medium
          .filter((item) => item.selected)
          .map((item) => item.name.trim())
          .join(', ') || 'No medium available';
    }
  }

  setArea(): void {
    this.area = this.school.totalArea || 1000;
  }

  isCategorySelected(categoryName: string): boolean {
    return this.school.category?.some(
      (item) => item.name === categoryName && item.selected
    );
  }
}
